import { RewardsAccount } from "redmond";

/**
 * card_product_used for the Pay Flex survey: the selected payment card's
 * product, else the active/default rewards account's product, else "".
 */
export const resolvePayFlexCardProduct = (
  selectedCardProduct: string,
  defaultAccount: RewardsAccount | undefined
): string => selectedCardProduct || defaultAccount?.productDisplayName || "";
